import { salesRepo } from '../repo/salesRepo';

export const salesService = {
    async getAll(params = {}) {
        try {
            const response = await salesRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getMyShops(params = {}) {
        try {
            const response = await salesRepo.getMyShops(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(salesId) {
        if (!salesId) {
            throw new Error('Sales ID is required');
        }
        try {
            const response = await salesRepo.getById(salesId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getBySeller(sellerId) {
        if (!sellerId) {
            throw new Error('Seller ID is required');
        }
        try {
            const response = await salesRepo.getBySeller(sellerId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByStock(stockId) {
        if (!stockId) {
            throw new Error('Stock ID is required');
        }
        try {
            const response = await salesRepo.getByStock(stockId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByDateRange(params = {}) {
        if (!params.start_date || !params.end_date) {
            throw new Error('Start date and end date are required');
        }
        try {
            const response = await salesRepo.getByDateRange(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats() {
        try {
            const response = await salesRepo.getStats();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.sellerId) {
            throw new Error('Seller ID is required');
        }
        if (!data.stockId) {
            throw new Error('Stock ID is required');
        }
        if (!data.selling_price || data.selling_price < 0) {
            throw new Error('Valid selling price is required');
        }
        if (data.no_of_unsold === undefined || data.no_of_unsold < 0) {
            throw new Error('Number of unsold items is required');
        }

        try {
            const response = await salesRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(salesId, data) {
        if (!salesId) {
            throw new Error('Sales ID is required');
        }
        try {
            const response = await salesRepo.update(salesId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await salesRepo.getByShop(shopId, params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStatsByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await salesRepo.getStatsByShop(shopId, params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(salesId) {
        if (!salesId) {
            throw new Error('Sales ID is required');
        }
        try {
            const response = await salesRepo.toggleStatus(salesId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async bulkUpdateStatus(data) {
        if (!data.sale_ids || !Array.isArray(data.sale_ids) || data.sale_ids.length === 0) {
            throw new Error('Sale IDs array is required');
        }
        if (!data.status) {
            throw new Error('Status is required');
        }
        try {
            const response = await salesRepo.bulkUpdateStatus(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async export(params = {}) {
        try {
            const response = await salesRepo.export(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStatsFromData(sales = []) {
        try {
            const stats = {
                total_sales: sales.length,
                total_revenue: 0,
                total_profit: 0,
                total_loss: 0,
                total_items_sold: 0,
                total_items_unsold: 0,
                completed: 0,
                pending: 0,
                cancelled: 0,
                active: 0
            };

            sales.forEach(sale => {
                stats.total_revenue += parseFloat(sale.actualTotalRevenue || 0);
                stats.total_profit += parseFloat(sale.actualProfit || 0);
                stats.total_loss += parseFloat(sale.actualLoss || 0);
                stats.total_items_sold += parseInt(sale.itemsSold || 0);
                stats.total_items_unsold += parseInt(sale.no_of_unsold || 0);

                const status = sale.status || 'active';
                if (status === 'completed') stats.completed++;
                else if (status === 'pending') stats.pending++;
                else if (status === 'cancelled') stats.cancelled++;
                else stats.active++;
            });

            stats.avg_profit_margin = stats.total_revenue > 0
                ? (stats.total_profit / stats.total_revenue) * 100
                : 0;

            return stats;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('SalesService Error:', error);
        return error.response?.data || error;
    }
};